import React from 'react';

import { SVGComponentProps } from './svg.types';

const TimeSheetSVG = ({
  fill = 'currentColor',
  size = '16',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
        {...otherProps}
      >
        <path
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M8 5.333v3.334M8 14.667a5.836 5.836 0 01-5.833-5.834A5.835 5.835 0 018 3a5.836 5.836 0 015.833 5.833"
        ></path>
        <path
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          d="M6 1.333h4M9.933 12.333v-.773c0-.953.68-1.347 1.507-.867l.667.387.666.387c.827.48.827 1.26 0 1.74l-.666.386-.667.387c-.827.48-1.507.087-1.507-.867v-.78z"
        ></path>
      </svg>
    </span>
  );
};

export default TimeSheetSVG;
